import { render, staticRenderFns } from "./Rate.vue?vue&type=template&id=7fe60170&scoped=true"
import script from "./Rate.vue?vue&type=script&lang=js"
export * from "./Rate.vue?vue&type=script&lang=js"
import style0 from "./Rate.vue?vue&type=style&index=0&id=7fe60170&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fe60170",
  null
  
)

export default component.exports